import {isTabletPortraitDown, TwoFactorType} from '@enter/core';
import {mdiArrowLeft} from '@mdi/js';
import {Icon} from '@mdi/react';
import {ContactSupport} from 'components';
import _ from 'lodash';
import {inject, observer} from 'mobx-react';
import React, {useContext, useEffect, useState} from 'react';
import {DialogContext} from 'services';
import {ChangeTwoFactorDialog} from '../components';
import {ISettingsPage} from '../shared';
import * as S from '../shared.styles';

export const TwoStepVerification: React.FunctionComponent = inject('rootStore')(
    observer(
        (props: ISettingsPage): React.ReactElement => {
            const rootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const dialogContext = useContext(DialogContext);

            const [enabled, setEnabled] = useState(rootStore.userTwoFactor);
            const [twoFactorType, setTwoFactorType] = useState(rootStore.userTwoFactorType);

            useEffect(() => {
                // NB: update if disable-dialog causes change
                setEnabled(rootStore.userTwoFactor);
                setTwoFactorType(rootStore.userTwoFactorType);
            }, [rootStore.userTwoFactor, rootStore.userTwoFactorType]);

            const handleCloseDialog = async (): Promise<void> => {
                dialogContext.hideDialog();
                await rootStore.loadUser();
            };
            const handleClickChangeTwoFactor = (): void => {
                dialogContext.showDialog({
                    props: {
                        onClose: handleCloseDialog,
                        disableBackdropClick: true,
                        disableEscapeKeyDown: true,
                        renderTitle: 'Update 2-step Verification',
                    },
                    Component: <ChangeTwoFactorDialog onClose={handleCloseDialog} twoFactorType={twoFactorType === TwoFactorType.SMS ? TwoFactorType.TOTP : TwoFactorType.SMS} />,
                });
            };

            return (
                <S.SubCategoryItem>
                    {isTabletPortraitDown() && (
                        <S.ReturnLink to="/settings/security-and-safety">
                            {(): React.ReactElement => <Icon path={mdiArrowLeft} size={1} />}
                        </S.ReturnLink>
                    )}
                    <S.SubCategoryH1>2-step Verification</S.SubCategoryH1>

                    <S.SubCategoryText>
                        2-step verification is required for all accounts. You may switch between using a phone or a TOTP (time-based one-time password) app, such as Google Authenticator or Authy.
                    </S.SubCategoryText>

                    {enabled && (
                        <>
                            <div>
                                {twoFactorType && <span>
                                    <S.SubCategoryText>Your 2-step verification type is currently set to <b>{twoFactorType.toString()}</b>.</S.SubCategoryText>
                                    <S.Button onClick={handleClickChangeTwoFactor}>
                                        {twoFactorType === TwoFactorType.SMS && <span>Switch to using a TOTP Application</span>}
                                        {twoFactorType === TwoFactorType.TOTP && <span>Switch to using SMS</span>}
                                    </S.Button>
                                    </span>
                                }
                                <ContactSupport
                                    action="change your credentials if you lose access to your device."
                                    subject="Need help with two-step verification"
                                />
                            </div>
                        </>
                    )}
                </S.SubCategoryItem>
            );
        },
    ),
);
